import { Text, useMutation, useTranslation } from '@obvio/app'
import {
  CheckboxInput,
  Form,
  FormPage,
  GridItem,
  Stack,
  Submit,
  SubmitState,
  TextArea,
  TextInput,
} from '@obvio/ui'
import { Label } from '@obvio/ui/Form/Inputs/utils'

import { GridSubmit } from './components'
import { FormMultiple } from './FormJoin/FormMultiple'
import { FormBarMargin } from './FormJoin/FormSection'
import { FadeIn } from '../FadeIn'

import type { ReactElement } from 'react'

type FormData = {
  name: string
  email: string
  phone: string
  site: string | undefined
  resume: string
  message: string | undefined
  exhibitions: string[]
}

export function FormCurator(): ReactElement {
  const { t } = useTranslation()
  const [sendMessage] = useMutation('curatorForm')

  const handleSubmit = async (values: FormData) => {
    await sendMessage(values)
    return SubmitState.OK
  }
  return (
    <Form onSubmit={handleSubmit}>
      <FormPage>
        <FadeIn>
          <FormBarMargin title="Your professional details" />
          <Stack kind="vertical">
            <TextInput name="name" label="Full name" />
            <TextInput name="email" label="Email address" />
            <TextInput name="phone" label="Phone number" />
            <TextInput name="site" label="Website" optional />
            <TextInput name="resume" label="Resume url" />
            <TextArea
              name="message"
              label="About you"
              rows={10}
              optional
              message={
                "We believe that every curator has a unique perspective and voice - share yours with us and let's make something amazing together."
              }
            />
            <FormMultiple
              label={t('joinForm.label.exhibitionsHistory')}
              name="exhibitions"
              defaultNum={2}
            />
            <Label inputKind="textarea">Interest areas</Label>
            <Stack spacing="medium" mobileKind="vertical">
              <CheckboxInput
                name="curatingExhibitions"
                label="Curating exhibitions"
              />
              <CheckboxInput name="curatorialTaxes" label="Curatorial taxes" />
              <CheckboxInput
                name="curatorialBlogPosts"
                label="Curatorial blog posts"
              />
              <CheckboxInput
                name="curatorialAdvisory"
                label="Curatorial advisory"
              />
              <CheckboxInput name="other" label="Other" />
            </Stack>
            <GridSubmit templateColumns="1fr 1fr" gap="medium">
              <GridItem>
                <CheckboxInput name="rodo" label={t('form.rodo')} required />
              </GridItem>
              <GridItem noCenter>
                <Submit>SEND APPLICATION</Submit>
              </GridItem>
            </GridSubmit>
          </Stack>
        </FadeIn>
      </FormPage>
      <FormPage>
        <FadeIn>
          <Text tag="h2" as="h4">
            {t('joinForm.sent')}
          </Text>
        </FadeIn>
      </FormPage>
    </Form>
  )
}
